var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"pa-0 pa-sm-3",attrs:{"fluid":""}},[(_vm.$featurePermissions.plannedServiceCRUD)?_c('planned-service-events'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }